import { ViewController, NavParams, ToastController } from 'ionic-angular';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Dock } from "../../models/Dock";
import { AppFacade } from '../../facade/app.facade';
import moment from 'moment';
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Subscription } from 'rxjs/Subscription';

/**
 * Generated class for the DockModal component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */
@Component({
    selector: 'dock-modal',
    templateUrl: 'dock-modal.html'
})
export class DockModal implements OnInit, OnDestroy {
    private subscriptions: Array<Subscription> = [];

    public item: Dock;
    public usedTrucks: Array<Number>;
    public usedTrailers: Array<Number>;

    public trucks$ = this.facade.trucks$;
    public trailers$ = this.facade.trailers$;

    public dockForm: FormGroup

    constructor(
        private viewCtrl: ViewController,
        private params: NavParams,
        public facade: AppFacade,
        private fb: FormBuilder,
        private toastCtrl: ToastController,
    ) {
        //
    }

    private truckTemplate(truck: any): string {
        if (!truck)
            return '';

        return `${truck.code} - ${truck.title} - ${truck.pretty_transporter}`;
    }

    private trailerTemplate(trailer: any): string {
        if (!trailer)
            return '';

        return `${trailer.code} - ${trailer.title} - ${trailer.pretty_transporter}`;
    }

    save() {
        // AWA: Fix for overriding form values as the select component for some reason inputs a whole object
        this.dockForm.value.truck_id = this.dockForm.value.truck_id.id;
        this.dockForm.value.trailer_id = this.dockForm.value.trailer_id.id;

        this.facade.updateDock(this.item.id, this.dockForm.value);
        this.viewCtrl.dismiss('saved')
        let toast = this.toastCtrl.create({
            message: 'Dock aangepast',
            duration: 3000,
        })
        toast.present()
    }

    dismiss() {
        this.viewCtrl.dismiss()
    }

    ngOnInit() {
        this.subscriptions.push(this.facade.docksOccupied$.subscribe((f) => {
            this.usedTrucks = f.map((d) => {
                return d.current.truck_id;
            });
        }));

        this.subscriptions.push(this.facade.docksOccupied$.subscribe((f) => {
            this.usedTrailers = f.map((d) => {
                return d.current.trailer_id;
            });
        }));



        this.item = Object.assign({}, this.params.data.dock)

        this.dockForm = this.fb.group({
            truck_id: [(this.item.current && this.item.current.truck_id ? this.item.current.truck_id : ''), Validators.compose([])],
            trailer_id: [(this.item.current && this.item.current.trailer_id ? this.item.current.trailer_id : ''), Validators.compose([])],
            status: [(this.item.current && this.item.current.status ? this.item.current.status : 0), Validators.compose([Validators.required])],
            time: [(this.item.current && this.item.current.time ? this.item.current.time : moment().toISOString()), Validators.compose([])],
        })


        this.trucks$ = this.trucks$.map((f) => {
            return f.filter((t) => {
                return (this.usedTrucks.indexOf(t.id) === -1 || this.dockForm.value.truck_id == t.id);
            })
        })

        this.trailers$ = this.trailers$.map((f) => {
            return f.filter((t) => {
                return (this.usedTrailers.indexOf(t.id) === -1 || this.dockForm.value.trailer_id == t.id);
            })
        })

    }

    ngOnDestroy() {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }
}



// WEBPACK FOOTER //
// ./src/components/dock-modal/dock-modal.ts